import type * as React from 'react'

import { type IBaseButtonProps } from './BaseButton'
import { SecondaryButtonStyled } from './styles/SecondaryButtonStyled'

export const SecondaryButton: React.FC<IBaseButtonProps> = SecondaryButtonStyled

SecondaryButton.displayName = 'SecondaryButton'
